// タイトル画面 (2026-10-31 に比較版 ?title=v9 で作り、11-01 に配布版の既定にした)。構図9 (霧の白) の背景に、ロゴ案2 (レイピアの I) を描き込んだ絵を敷く。
//   作者の答え (db answers/title-logo9-1031・logo=2): 「LUNA（月）がRE（再）と読めてむしろいい」
//   「メニューの字はUIとかと統一してほしい＋レイピアのIでそれぞれのフォント確認したうえで決定したい」。
//   メニューの字 = 配布版の UI と同じ同梱の Zen Old Mincho (11-01 作者 font=1・src/ui_font.ts)。11-01 作者「タイトルとかも変わってないけど」で、決まっていた背景・ロゴ・字を配布版の既定にした。
//   前のタイトル画面は開発版 ?title=old。URL は game.ts の DEV の箱の中だけで読む。記録 = docs/research/2026-10-31-title-menu-font-unify.md
//   絵 = public/bg/title_v9.webp (Codex の logo2_rapier_v1 を 1600x900 に縮めた物)。ロゴは絵に入っているので字の LUNAIRE は描かない。
import { UI_SERIF } from './ui_font'

export const TITLE_V9_BG = '/bg/title_v9.webp'
// 刃の先は絵の高さの 71% (y≈384)。メニューはその下にロゴの中心 (x=480) でそろえる。
export const TITLE_V9_MENU_TOP = 416
export const TITLE_V9_MENU_ROW_H = 28
export const TITLE_V9_MENU_FONT_PX = 17
export const TITLE_V9_MENU_W = 200

let on = true

export function setTitleLook(look: string | null): void {
  on = look !== 'old'
}
export function titleV9(): boolean { return on }
export function titleV9Font(weight = 500, px = TITLE_V9_MENU_FONT_PX): string {
  return `${weight} ${px}px ${UI_SERIF}`
}
